import toastLib, { Toaster, type ToastOptions } from "react-hot-toast";

const DEFAULT_TOAST_OPTIONS: ToastOptions = {
  style: {
    background: "#23303E",
    color: "#FFFFFF",
  },
};

type ToastMessage = Parameters<typeof toastLib>[0];
type ToastShowOptions = Parameters<typeof toastLib>[1];
type ToastDispatchOptions = ToastShowOptions & { toasterId?: string };

export interface ToastProps {
  reverseOrder?: boolean;
  gutter?: number;
  containerClassName?: string;
  toasterId?: string;
}

export const toast = {
  show(message: ToastMessage, options?: ToastDispatchOptions) {
    return toastLib(message, options);
  },
  success(message: ToastMessage, options?: ToastDispatchOptions) {
    return toastLib.success(message, options);
  },
  error(message: ToastMessage, options?: ToastDispatchOptions) {
    return toastLib.error(message, options);
  },
  loading(message: ToastMessage, options?: ToastDispatchOptions) {
    return toastLib.loading(message, options);
  },
  promise: toastLib.promise,
  dismiss: toastLib.dismiss,
  remove: toastLib.remove,
};

export function Toast({
  reverseOrder = false,
  gutter = 8,
  containerClassName,
  toasterId,
}: ToastProps) {
  return (
    <Toaster
      position="bottom-center"
      toastOptions={DEFAULT_TOAST_OPTIONS}
      reverseOrder={reverseOrder}
      gutter={gutter}
      containerClassName={containerClassName}
      {...(toasterId
        ? ({ toasterId } as unknown as Record<string, unknown>)
        : {})}
    />
  );
}
